import { render, staticRenderFns } from "./AttachmentMessageRoomComponents.vue?vue&type=template&id=095d5956&scoped=true&"
import script from "./AttachmentMessageRoomComponents.vue?vue&type=script&lang=js&"
export * from "./AttachmentMessageRoomComponents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.10.1_@vue+compiler-sfc@3.5.29_babel-core@7.0.0-bridge.0_@babel+core@7.24._f07fc21c0eeec7f6e04fb4ae2769cbbc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095d5956",
  null
  
)

export default component.exports